export const data = [
  {
    id: "01",
    header: "Create and share your photo stories.",
    details:
      "Photosnap is a platform for photographers and visual storytellers. We make it easy to share photos, tell stories and connect with others.",
    image: {
      desktop: require("./assets/home/desktop/create-and-share.jpg"),
      tablet: require("./assets/home/tablet/create-and-share.jpg"),
      mobile: require("./assets/home/mobile/create-and-share.jpg"),
    },
    design: "original",
   
  },
  {
    id: "02",
    header: "Beautiful Stories every time",
    details:
      "We provide design templates to ensure your stories look terrific. Easily add photos, text, embed maps and media from other networks. Then share your story with everyone.",
    image: {
      desktop: require("./assets/home/desktop/beautiful-stories.jpg"),
      tablet: require("./assets/home/tablet/beautiful-stories.jpg"),
      mobile: require("./assets/home/mobile/beautiful-stories.jpg"),
    },
    design: "reverse",
   
  },
  {
    id: "03",
    header: "designed for everyone",
    details:
      "Photosnap can help you create stories that resonate with your audience.  Our tool is designed for photographers of all levels, brands, businesses you name it.",
    image: {
      desktop: require("./assets/home/desktop/designed-for-everyone.jpg"),
      tablet: require("./assets/home/tablet/designed-for-everyone.jpg"),
      mobile: require("./assets/home/mobile/designed-for-everyone.jpg"),
    },
    design: "reverse",
   
  },
  {
    id: "04",
    header: "features",
    details:
      "We make sure all of features are designed to be loved by every aspiring and even professional photographers who wanted to share their stories.",
    image: {
      desktop: require("./assets/features/desktop/hero.jpg"),
      tablet: require("./assets/features/tablet/hero.jpg"),
      mobile: require("./assets/features/mobile/hero.jpg"),
    },
    design: "original",
   
  },
  {
    id: "05",
    header: "pricing",
    details:
      "Create a 'your' stories, Photosnap is a platform for photographers and visual storytellers. It's the simple way to create and share your photos.",
    image: {
      desktop: require("./assets/pricing/desktop/hero.jpg"),
      tablet: require("./assets/pricing/tablet/hero.jpg"),
      mobile: require("./assets/pricing/mobile/hero.jpg"),
    },
    design: "original",
 
  },
];
